(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

document.addEventListener('DOMContentLoaded', function () {

	document.querySelector('#anchor-link').addEventListener('click', function (e) {

		e.preventDefault();

		window.scrollTo({
			top: window.innerHeight / 2,
			left: 0,
			behavior: 'smooth'
		});
	});

	new Typewriter('#representations', {
		strings: [''],
		cursor: null,
		autoStart: true,
		loop: false,
		delay: 25
	}).typeString('EPRESENTATIONS and');

	setTimeout(function () {

		new Typewriter('#reconfigurations', {
			strings: [''],
			cursor: null,
			autoStart: true,
			loop: false,
			delay: 25
		}).typeString('ECONFIGURATIONS of the');
	}, 200);

	setTimeout(function () {

		new Typewriter('#digital', {
			strings: [''],
			cursor: null,
			autoStart: true,
			loop: false,
			delay: 25
		}).typeString('IGITAL in Swedish Literature and Art, 1950–2010');
	}, 400);

	var archiveTyper = new Typewriter('#archive', {
		strings: [''],
		cursor: null,
		autoStart: true,
		loop: false,
		delay: 25
	}).typeString('RCHIVE');

	new Typewriter('#book', {
		strings: [''],
		cursor: null,
		autoStart: true,
		loop: false,
		delay: 25
	}).typeString('OOK');

	new Typewriter('#conference', {
		strings: [''],
		cursor: null,
		autoStart: true,
		loop: false,
		delay: 25
	}).typeString('ONFERENCE');

	document.getElementById('archive-link').addEventListener('mouseleave', function () {});
});

},{}]},{},[1])

